import { createAction } from '@reduxjs/toolkit';
import type { IErrorType } from '../../constants/types';
import type { IAdHubConnectionsResponse, IAdHubOAuthExchangeResult } from '../../types/global/adhubConnections.types';
import {
    types,
    type IDisconnectAdHubPlatformPayload,
    type IExchangeAdHubMetaOAuthPayload,
    type IFetchAdHubMetaOAuthUrlPayload,
} from './types';

export const fetchAdHubConnections = createAction<string>(types.FETCH_CONNECTIONS);
export const fetchAdHubConnectionsSuccess = createAction<IAdHubConnectionsResponse>(types.FETCH_CONNECTIONS_SUCCESS);
export const fetchAdHubConnectionsFail = createAction<IErrorType>(types.FETCH_CONNECTIONS_FAIL);

export const fetchAdHubMetaOAuthUrl = createAction<IFetchAdHubMetaOAuthUrlPayload>(types.FETCH_META_OAUTH_URL);
export const fetchAdHubMetaOAuthUrlSuccess = createAction<string>(types.FETCH_META_OAUTH_URL_SUCCESS);
export const fetchAdHubMetaOAuthUrlFail = createAction<IErrorType>(types.FETCH_META_OAUTH_URL_FAIL);

export const exchangeAdHubMetaOAuth = createAction<IExchangeAdHubMetaOAuthPayload>(types.EXCHANGE_META_OAUTH);
export const exchangeAdHubMetaOAuthSuccess = createAction<IAdHubOAuthExchangeResult>(types.EXCHANGE_META_OAUTH_SUCCESS);
export const exchangeAdHubMetaOAuthFail = createAction<IErrorType>(types.EXCHANGE_META_OAUTH_FAIL);

export const disconnectAdHubPlatform = createAction<IDisconnectAdHubPlatformPayload>(types.DISCONNECT_PLATFORM);
export const disconnectAdHubPlatformSuccess = createAction<void>(types.DISCONNECT_PLATFORM_SUCCESS);
export const disconnectAdHubPlatformFail = createAction<IErrorType>(types.DISCONNECT_PLATFORM_FAIL);
